export default __webpack_public_path__ + "static/media/iconSpartanGoldenGate.5052faf4.svg";